import React, { useState, useContext } from "react";
import { Box, Tabs, Tab, Typography } from "@mui/material";
import { utilities as utilitiesFunction } from "./repairUtilities";
import { LanguageContext } from "../../context/languageContext";
import { useNavigate } from "react-router-dom";

const RepairPage = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate(); // Get the navigate function from the react-router-dom

  const { translations, language, changeLanguage } =
    useContext(LanguageContext);
  const utilities = utilitiesFunction(translations);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);

    if (newValue === 1) {
      navigate("/repair/rrf");
    } else {
      navigate("/repair/search");
    }
  };

  return (
    <>
      <Box
        sx={{
          backgroundColor: "var(--reach-blue)",
          height: "35px",
          display: "flex",
          alignItems: "center",
          justifyContent: "left",
        }}
      >
        <Typography
          sx={{ fontFamily: "BrightstarSans-Bold", color: "#FFFFFF", ml: 2 }}
        >
          {"Repair Utilities"}
        </Typography>
      </Box>
      <Box
        sx={{
          backgroundColor: "var(--dust-white)",
          minHeight: "calc(100vh - 35px - 64px)",
          display: "flex",
          flexDirection: "column",
        }}
      >
        {Array.isArray(utilities) && (
          <Tabs
            value={selectedTab}
            onChange={handleTabChange}
            aria-label="Contact Center Tabs"
            indicatorColor="primary"
            textColor="primary"
            sx={{ marginBottom: 2 }}
          >
            {utilities.map((utility, index) => (
              <Tab key={index} label={utility.tab} />
            ))}
          </Tabs>
        )}
        <Box
          sx={{
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            padding: 2,
          }}
        >
          {Array.isArray(utilities) &&
            utilities[selectedTab]?.items.map((item, index) => (
              <Box key={index} sx={{ flexGrow: 1, marginBottom: 2 }}>
                {item.component}
              </Box>
            ))}
        </Box>
      </Box>
    </>
  );
};

export default RepairPage;
